

export const KEY_LISTFORM_ATTACHMENTLINKMODE = 'listform.attachmentlinkmode';

export const ATTACHMENTLINKMODE_DEFAULT = 'default';
export const ATTACHMENTLINKMODE_BROWSER = 'browser';
export const ATTACHMENTLINKMODE_NORMAL = 'normal';